import {
	Alert,
	Box,
	Button,
	CssBaseline,
	Grid,
	Snackbar,
	Typography,
} from '@mui/material';

import { createTheme, ThemeProvider } from '@mui/material/styles';

import manageProfileIcon from '../../../../assets/logos/manageProfileicon.png';

import bundlesIcon from '../../../../assets/logos/bundlesIcon.png';

import insurranceIcon from '../../../../assets/logos/insurranceIcon.png';

import customizeIcon from '../../../../assets/logos/customizeIcon.png';

import staffIcon from '../../../../assets/logos/staffIcon.png';

import messagesIcon from '../../../../assets/logos/messagesIcon.png';

import hospitalIcon from '../../../../assets/logos/hospitalList.png';

import ManageProfile from './ManageProfile';

import React, { useEffect, useState } from 'react';

import Bundles from './Bundles';

import Payer from './payer/Payer';

import Index from './addStaff/index';

import Messages from './messagesSetting/Messages';

import HospitalList from './HospitalList';

import CustomizeDX from './customizeDx/CustomizeDX';

import CustomizeCPT from './customizeCpt/CustomizeCPT';
import { Add, ExpandCircleDown, Grid3x3 } from '@mui/icons-material';
import Addpayer from './payer/Addpayer';
import AddStaff from './addStaff/AddStaff';
import EMRimport from './EMRimport';
import FavouritePatientList from './FavouritePatientList';

function Settings() {
	const storedPage = localStorage.getItem('currentPage');
	// const [currentPage, setCurrentPage] = useState(storedPage || 'manageProfile');
	const [currentPage, setCurrentPage] = useState('manageProfile');
	const [showMenubar, setShowMenubar] = useState(false);
	const [openSnackbar, setOpenSnackbar] = useState({
		openBar: false,
		barColor: 'green',
		snakbarFor: null,
	});

	const handleButtonClick = (page) => {
		setCurrentPage(page);
		localStorage.setItem('currentPage', page);
	};

	useEffect(() => {
		return () => {
			localStorage.removeItem('currentPage');
		};
	}, []);

	const renderPageContent = () => {
		switch (currentPage) {
			case 'manageProfile':
				return <ManageProfile />;

			case 'bundles':
				return <Bundles />;

			case 'insurrance':
				return <Payer />;
			case 'addPayer':
				// sending this prop in my AddPayer Component so I can render my page on the click of modal Cancel button
				return (
					<Addpayer
						renderHandleFromChild={setCurrentPage}
						openSanckbarFromChild={setOpenSnackbar}
					/>
				);

			case 'viewStaff':
				return <Index />;
			case 'addStaff':
				return (
					<AddStaff
						renderHandleFromChild={setCurrentPage}
						openSanckbarFromChild={setOpenSnackbar}
					/>
				);

			case 'messages':
				return <Messages />;

			case 'hospital':
				return <HospitalList />;
			case 'addHospital':
				return (
					<HospitalList
						openModalIntialy={'openModal'}
						renderHandleFromChild={setCurrentPage}
					/>
				);

			case 'cptCustom':
				return <CustomizeCPT />;

			case 'dxCustom':
				return <CustomizeDX />;
			case 'EMR':
				return <EMRimport />;
			case 'Favourites':
				return <FavouritePatientList />;

			default:
				return <ManageProfile />;
		}
	};

	const defaultTheme = createTheme();
	const oid = localStorage.getItem('OSW_id');
	return (
		<ThemeProvider theme={createTheme()}>
			{/* new Settings header starts here */}
			<Grid
				container
				margin={'auto'}
				// width={'95%'}
				sx={{
					transition: ' all 0.5s ease-in-out',
					zIndex: 0,
					opacity: {
						xs: !showMenubar ? '0' : '1',
						sm: !showMenubar ? '0' : '1',
						md: !showMenubar ? '0' : '1',
						lg: '1',
						xl: '1',
					},
					visibility: {
						xs: !showMenubar ? 'hidden' : 'visible',
						sm: !showMenubar ? 'hidden' : 'visible',
						md: !showMenubar ? 'hidden' : 'visible',
						lg: 'visible',
						xl: 'visible',
					},

					height: {
						xs: showMenubar ? '250px' : '0px',
						sm: showMenubar ? '250px' : '0px',
						md: showMenubar ? '500px' : '0px',
						lg: '40px',
						xl: '54px',
					},
					// border: '2px solid black',
				}}
				bgcolor={'#008CD1'}
				borderRadius={'0px 0px 12px 12px'}
			>
				<Grid item xs={12} sm={12} md={12} lg={1.3} xl={1.3}>
					<Box
						// sx={{  }}
						onClick={() => setCurrentPage('manageProfile')}
						width={'100%'}
						sx={{
							height: {
								xl: '54px',
								lg: '40px',
							},
							// border: '8px solid black',
							cursor: 'pointer',
						}}
						display={'flex'}
						justifyContent={'center'}
						alignItems={'center'}
						style={
							currentPage == 'manageProfile'
								? {
										//border: '1px inset white',
										backgroundColor: '#005385',
										borderRadius: '0px 0px 12px 12px',
									}
								: {}
						}
					>
						<Typography
							fontWeight={500}
							sx={{
								fontSize: {
									xl: '15px',
									lg: '10px',
									md: '9px',
									sm: '9px',
									xs: '9px',
								},
							}}
							color={'#FBFBFB'}
							fontFamily={'Poppins'}
						>
							Manage Profile
						</Typography>
					</Box>
				</Grid>
				{/* <Grid item xs={12} sm={12} md={12} lg={1.3} xl={1.3}>
					<Box
						// sx={{ cursor: 'pointer' }}
						onClick={() => setCurrentPage('bundles')}
						width={'100%'}
						sx={{ height:{
							xl:"54px
							lg:"40px
							md:"35px"
						} }}
						display={'flex'}
						justifyContent={'center'}
						alignItems={'center'}
						style={
							currentPage == 'bundles'
								? {
										backgroundColor: '#005385',
										borderRadius: '0px 0px 12px 12px',
									}
								: {}
						}
					>
						<Typography
							fontWeight={500}
							sx={{
								fontSize:{
									xl:"15px"
									lg:"10px
									md:'9px'"
sm:'9px',
xs:"9px"

								}
							}}
							color={'#FBFBFB'}
							fontFamily={'Poppins'}
						>
					
							Hospitals
						</Typography>
					</Box>
				</Grid> */}
				<Grid item xs={12} sm={12} md={12} lg={1.3} xl={1.3}>
					<Box
						// sx={{ cursor: 'pointer' }}
						onClick={() => setCurrentPage('insurrance')}
						// width={'100%'}
						sx={{
							height: {
								xl: '54px',
								lg: '40px',
							},
							cursor: 'pointer',
						}}
						display={'flex'}
						justifyContent={'center'}
						alignItems={'center'}
						style={
							currentPage == 'insurrance'
								? {
										//border: '1px inset white',
										backgroundColor: '#005385',
										borderRadius: '0px 0px 12px 12px',
									}
								: currentPage == 'addPayer'
									? {
											//border: '1px inset white',
											backgroundColor: '#005385',
											borderRadius: '0px 0px 12px 12px',
										}
									: {}
						}
					>
						<Typography
							fontWeight={500}
							sx={{
								fontSize: {
									xl: '15px',
									lg: '10px',
									md: '9px',
									sm: '9px',
									xs: '9px',
								},
							}}
							color={'#FBFBFB'}
							fontFamily={'Poppins'}
						>
							Payer
						</Typography>
					</Box>
				</Grid>
				<Grid item xs={12} sm={12} md={12} lg={1.3} xl={1.3}>
					<Box
						// sx={{ cursor: 'pointer' }}
						onClick={() => setCurrentPage('viewStaff')}
						// width={'100%'}
						sx={{
							height: {
								xl: '54px',
								lg: '40px',
							},
							cursor: 'pointer',
						}}
						display={'flex'}
						justifyContent={'center'}
						alignItems={'center'}
						style={
							currentPage == 'viewStaff' || currentPage == 'addStaff'
								? {
										//border: '1px inset white',

										backgroundColor: '#005385',
										borderRadius: '0px 0px 12px 12px',
									}
								: {}
						}
					>
						<Typography
							fontWeight={500}
							sx={{
								fontSize: {
									xl: '15px',
									lg: '10px',
									md: '9px',
									sm: '9px',
									xs: '9px',
								},
							}}
							color={'#FBFBFB'}
							fontFamily={'Poppins'}
						>
							Add Staff
						</Typography>
					</Box>
				</Grid>
				{/* <Grid item xs={12} sm={12} md={12} lg={1.3} xl={1.3}>
					<Box
						// sx={{ cursor: 'pointer' }}
						onClick={() => setCurrentPage('messages')}
						width={'100%'}
						sx={{ height:{
							xl:"54px
							lg:"40px
							md:"35px"
						} }}
						display={'flex'}
						justifyContent={'center'}
						alignItems={'center'}
						style={
							currentPage == 'messages'
								? {
										//border: '1px inset white',

										backgroundColor: '#005385',
										borderRadius: '0px 0px 12px 12px',
									}
								: {}
						}
					>
						<Typography
							fontWeight={500}
							sx={{
								fontSize:{
									xl:"15px"
									lg:"10px
									md:'9px'"
sm:'9px',
xs:"9px"

								}
							}}
							color={'#FBFBFB'}
							fontFamily={'Poppins'}
						>
							Messages
						</Typography>
					</Box>
				</Grid> */}
				<Grid item xs={12} sm={12} md={12} lg={1.3} xl={1.3}>
					<Box
						// sx={{ cursor: 'pointer' }}
						onClick={() => setCurrentPage('hospital')}
						width={'100%'}
						sx={{
							height: {
								xl: '54px',
								lg: '40px',
							},
							cursor: 'pointer',
						}}
						display={'flex'}
						justifyContent={'center'}
						alignItems={'center'}
						style={
							currentPage === 'hospital' || currentPage === 'addHospital'
								? {
										//border: '1px inset white',
										backgroundColor: '#005385',
										borderRadius: '0px 0px 12px 12px',
									}
								: {}
						}
					>
						<Typography
							fontWeight={500}
							sx={{
								fontSize: {
									xl: '15px',
									lg: '10px',
									md: '9px',
									sm: '9px',
									xs: '9px',
								},
							}}
							color={'#FBFBFB'}
							fontFamily={'Poppins'}
						>
							Hospital List
						</Typography>
					</Box>
				</Grid>
				<Grid item xs={12} sm={12} md={12} lg={1.5} xl={1.5}>
					<Box
						// sx={{ cursor: 'pointer' }}
						onClick={() => setCurrentPage('cptCustom')}
						width={'100%'}
						sx={{
							height: {
								xl: '54px',
								lg: '40px',
							},
							cursor: 'pointer',
						}}
						display={'flex'}
						justifyContent={'center'}
						alignItems={'center'}
						style={
							currentPage == 'cptCustom'
								? {
										//border: '1px inset white',

										backgroundColor: '#005385',
										borderRadius: '0px 0px 12px 12px',
									}
								: {}
						}
					>
						<Typography
							fontWeight={500}
							sx={{
								fontSize: {
									xl: '15px',
									lg: '10px',
									md: '9px',
									sm: '9px',
									xs: '9px',
								},
							}}
							color={'#FBFBFB'}
							fontFamily={'Poppins'}
						>
							Customize CPT List
						</Typography>
					</Box>
				</Grid>
				<Grid item xs={12} sm={12} md={12} lg={1.5} xl={1.5}>
					<Box
						// sx={{ cursor: 'pointer' }}
						onClick={() => setCurrentPage('dxCustom')}
						width={'100%'}
						sx={{
							height: {
								xl: '54px',
								lg: '40px',
							},
							cursor: 'pointer',
						}}
						display={'flex'}
						justifyContent={'center'}
						alignItems={'center'}
						style={
							currentPage == 'dxCustom'
								? {
										//border: '1px inset white',

										backgroundColor: '#005385',
										borderRadius: '0px 0px 11px 11px',
									}
								: {}
						}
					>
						<Typography
							fontWeight={500}
							sx={{
								fontSize: {
									xl: '15px',
									lg: '10px',
									md: '9px',
									sm: '9px',
									xs: '9px',
								},
							}}
							color={'#FBFBFB'}
							fontFamily={'Poppins'}
						>
							Customize DX List
						</Typography>
					</Box>
				</Grid>
				<Grid item xs={12} sm={12} md={12} lg={1.5} xl={1.5}>
					<Box
						// sx={{ cursor: 'pointer' }}
						onClick={() => setCurrentPage('Favourites')}
						width={'100%'}
						sx={{
							height: {
								xl: '54px',
								lg: '40px',
							},
							cursor: 'pointer',
						}}
						display={'flex'}
						justifyContent={'center'}
						alignItems={'center'}
						style={
							currentPage == 'Favourites'
								? {
										//border: '1px inset white',

										backgroundColor: '#005385',
										borderRadius: '0px 0px 11px 11px',
									}
								: {}
						}
					>
						<Typography
							fontWeight={500}
							sx={{
								fontSize: {
									xl: '15px',
									lg: '10px',
									md: '9px',
									sm: '9px',
									xs: '9px',
								},
							}}
							color={'#FBFBFB'}
							fontFamily={'Poppins'}
						>
							Fav Patient List
						</Typography>
					</Box>
				</Grid>
				{oid != 'null' && (
					<Grid item xs={12} sm={12} md={12} lg={1.5} xl={1.5}>
						<Box
							// sx={{ cursor: 'pointer' }}
							onClick={() => setCurrentPage('EMR')}
							width={'100%'}
							sx={{
								height: {
									xl: '54px',
									lg: '40px',
								},
								cursor: 'pointer',
							}}
							display={'flex'}
							justifyContent={'center'}
							alignItems={'center'}
							style={
								currentPage == 'EMR'
									? {
											//border: '1px inset white',

											backgroundColor: '#005385',
											borderRadius: '0px 0px 11px 11px',
										}
									: {}
							}
						>
							<Typography
								fontWeight={500}
								sx={{
									fontSize: {
										xl: '15px',
										lg: '10px',
										md: '9px',
										sm: '9px',
										xs: '9px',
									},
									display: 'flex',
									alignItems: 'center',
								}}
								color={'#FBFBFB'}
								fontFamily={'Poppins'}
							>
								{/* <AddIcon fontSize="small" /> */}
								Import
							</Typography>
						</Box>
					</Grid>
				)}
			</Grid>
			{/* This box will shown only  small screens  xs,sm,md */}
			<Box
				sx={{
					opacity: { xs: '1', sm: '1', md: '1', lg: '0', xl: '0' },
					width: { xs: '100%', sm: '100%', md: '100%', lg: '0%', xl: '0%' },
					height: { xs: '40px', sm: '40px', md: '40px', lg: '0px', xl: '0px' },
					bgcolor: '#008CD1',
					border: '1px solid #008CD1',
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
					borderRadius: '0px 0px 12px 12px',
				}}
			>
				<ExpandCircleDown
					sx={{
						fontSize: '45px',
						color: 'whitesmoke',
						cursor: 'pointer',
						transform: showMenubar ? `rotate(180deg)` : '',
					}}
					onClick={() => {
						console.log(`clicking`);
						setShowMenubar((prev) => !prev);
					}}
				/>
			</Box>
			<Box
				width={'95%'}
				margin={'auto'}
				height={`${currentPage === 'cptCustom' || currentPage === 'dxCustom' || currentPage === 'EMR' || currentPage === 'Favourites' || currentPage === 'manageProfile' || currentPage === 'bundles' ? '0px' : '40px'}`}
			>
				{/* <Box ml={1} mt={1}>
					<Typography fontWeight={600} fontSize={'18px'} color={'#292929'}>
						{currentPage == 'manageProfile'
							? 'Manage Profile'
							: currentPage == 'bundles'
								? 'Hospitals List'
								: currentPage == 'insurrance'
									? 'Payer'
									: currentPage == 'viewStaff'
										? 'Add Staff'
										: currentPage == 'messages'
											? 'Messages'
											: currentPage == 'hospital' ||
												  currentPage == 'addHospital'
												? 'Hospitatl List'
												: currentPage == 'dxCustom'
													? 'Customize Dx List'
													: ''}
					</Typography>
				</Box> */}
				<Box fontWeight={400} fontSize={'14px'} color={'#292929'}>
					{/* <Typography > */}
					{currentPage == 'manageProfile' ? (
						''
					) : currentPage == 'bundles' ? (
						''
					) : currentPage == 'insurrance' ? (
						<Box
							// width={'100%'}
							display={'flex'}
							sx={{
								justifyContent: {
									xs: 'flex-start',
									sm: 'flex-start',
									md: 'flex-start',
									lg: 'flex-end',
									xl: 'flex-end',
								},
							}}
						>
							<Button
								onClick={() => {
									setCurrentPage('addPayer');
								}}
								sx={{
									// width: '179px',
									height: {
										xs: '30px',
										sm: '30px',
										md: '30px',
										lg: '30px',
										xl: '30px',
									},
									bgcolor: '#00A2E8',
									borderRadius: '6px',
									border: '1px solid white',
									color: '#FFFFFF',
									'&:hover': {
										background: '#00A2E8',
									},
									// display: 'flex',
									// gap: 1,
								}}
							>
								<Add />
								<span
									style={{
										fontSize: '18px',
										fontWeight: 400,
										fontFamily: 'Poppins',
									}}
								>
									Add Payer
								</span>
							</Button>
						</Box>
					) : currentPage == 'viewStaff' ? (
						<Box
							width={'100%'}
							display={'flex'}
							sx={{
								justifyContent: {
									xs: 'flex-start',
									sm: 'flex-start',
									md: 'flex-start',
									lg: 'flex-end',
									xl: 'flex-end',
								},
							}}
						>
							<Button
								onClick={() => {
									setCurrentPage('addStaff');
								}}
								sx={{
									// width: '179px',
									height: {
										xs: '30px',
										sm: '30px',
										md: '30px',
										lg: '30px',
										xl: '30px',
									},
									bgcolor: '#00A2E8',
									borderRadius: '6px',
									border: '1px solid white',
									color: '#FFFFFF',
									'&:hover': {
										background: '#00A2E8',
									},
									display: 'flex',
									gap: 1,
								}}
								startIcon={<Add />}
							>
								Add Staff
							</Button>
						</Box>
					) : currentPage == 'messages' ? (
						'Manage Your Messages Here'
					) : currentPage == 'hospital' || currentPage == 'addHospital' ? (
						<Box
							width={'100%'}
							display={'flex'}
							sx={{
								justifyContent: {
									xs: 'flex-start',
									sm: 'flex-start',
									md: 'flex-start',
									lg: 'flex-end',
									xl: 'flex-end',
								},
							}}
						>
							<Button
								onClick={() => {
									setCurrentPage('addHospital');
								}}
								sx={{
									width: '179px',
									height: {
										xs: '30px',
										sm: '30px',
										md: '30px',
										lg: '30px',
										xl: '30px',
									},
									bgcolor: '#00A2E8',
									borderRadius: '6px',
									border: '1px solid white',
									color: '#FFFFFF',
									'&:hover': {
										background: '#00A2E8',
									},
									display: 'flex',
									gap: 1,
								}}
							>
								<Add />
								<span
									style={{
										fontSize: '18px',
										fontWeight: 400,
										fontFamily: 'Poppins',
									}}
								>
									Add Hospital
								</span>
							</Button>
						</Box>
					) : (
						''
					)}
					{/* </Typography> */}
				</Box>
			</Box>
			<Grid
				container
				component="main"
				justifyContent={'center'}
				sx={{
					background: 'white',
					// padding: '5px',
					borderRadius: '5px',
					// height: '90%',
				}}
			>
				<CssBaseline />

				<Grid
					item
					lg={11.5}
					xl={11.5}
					md={11.5}
					sm={11.5}
					xs={11.5}
					sx={
						{
							// background: 'white',
							// borderRadius: '12px',
							// padding: '12px 7px',
							// border: '1px solid #00000026',
						}
					}
				>
					{renderPageContent()}
				</Grid>
			</Grid>
			{/* 
			// READ IT
		// I am creating this snackbar just for those components whoose ADD Button is in Parent Component (setting.js) like Add Payer and Add Staff etc, whenever add payer, Add Staff modal ADD button clicked this snackbar will open because its open function fire from AddPayer,AddStaff  component thorugh props */}
			{/* SnackBar */}
			<Snackbar
				open={openSnackbar?.openBar}
				autoHideDuration={1800}
				onClose={() => {
					setOpenSnackbar({ openBar: false, barColor: 'green' });
				}}
				anchorOrigin={{ vertical: 'center', horizontal: 'center' }}
			>
				<Alert
					onClose={() => {
						setOpenSnackbar({ openBar: false, barColor: 'green' });
					}}
					severity={openSnackbar?.barColor === 'green' ? 'success' : 'error'}
					variant="filled"
					sx={{
						width: '100%',
						height: '3.5rem',
						textAlign: 'center',
						fontSize: '1.1rem',
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
					}}
					action={
						<React.Fragment>
							<span
								onClick={() => {
									setOpenSnackbar({ openBar: false, barColor: 'green' });
								}}
								style={{
									cursor: 'pointer',
									m: 'auto 0',
									fontSize: '13px',
									color: 'rgb(231, 231, 231)',
								}}
							>
								Close
							</span>
						</React.Fragment>
					}
				>
					{openSnackbar?.barColor === 'green' &&
					openSnackbar?.snakbarFor === 'staff'
						? 'Staff Added Successfully!'
						: openSnackbar?.barColor === 'green' &&
							  openSnackbar?.snakbarFor === 'payer'
							? 'Payer Added Successfully!'
							: 'Error!'}
				</Alert>
			</Snackbar>
		</ThemeProvider>
	);
}

export default Settings;
